import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues } from '@dbk-legacy/muster/utils';
import { AsyncStorage } from 'react-native';
import { isEmpty } from 'lodash';
import { Base64 } from 'js-base64';
import startOfToday from 'date-fns/start_of_today';
import { addDays } from '../../../../src/utils/date';
import config from '../../../../src/data/settings';
import { VASCO_FLOW, VASCO_MODAL_TYPES, ENTITLEMENT, ECREDENTIALS, RM_ACCESS, VASCO_API_ERROR_CODES, ALERT_CATEGORY } from '../../../../src/constants';
import Guid from '../../../../src/utils/guid';
import isValidJsonString from '../../../../src/utils/is-valid-json-string';
import { EBANKINGWEBLUX, EBANKINGWEBUK } from '../constants';
import envConfig from '../../../../db-env-build';
import languageData from '../data/language-list.json';

export default () => {
  const today = startOfToday();
  const yesterday = addDays(-1, today);
  const past7Days = addDays(-6, yesterday);
  return muster()
    .path('portfolio.reRenderPage', {
      call: async ({ req }, { get, set, call }) => {
        const { path } = req.args[0];
        call('ui.history.replace', { pathname: '/progressicon' });
        setTimeout(() => {
          call('ui.history.replace', { pathname: path });
        }, 1);
      }
    })
    .path('portfolio.selectedAssetDesc', variable())
    .path('inactive.onPathChangedEventForCh', {
      call: async ({ req }, { get, set, call }) => {
        const assets = ['genericAssets'];
        assets.forEach(item => {
          call(`ui.state.portfolio.${item}.resetSort`);
          set(`portfolio.${item}.positions.pageOffset`, 0);
          set(`ui.state.position.transactionPageOffset`, 0);
        });
      }
    })
    .path('income.getTransactionHistoryCH', {
      call: async ({ req }, { get, set, call, watchValues }) => {
        console.log("income.getTransactionHistoryCH called");

        const prodType = await getValues(get('income.ieProdtype'));
        const portfolioId = await getValues(get('app.user.selectedPortfolioId'));
        const startDate = await getValues(get('income.startDate'));
        const endDate = await getValues(get('income.endDate'));
        const incomeExpenseSwitch = await getValues(get('income.incomeExpenseSwitch'));
        let ieFlag = null;
        if (incomeExpenseSwitch == 0) {
          ieFlag = 'I';
        } else {
          ieFlag = 'E';
        }
        let [oReturn] = '';
        if(envConfig.envConfig === EBANKINGWEBLUX){
          const portfolioIdencoded = Base64.encode(portfolioId);
          [oReturn] = await getValues(get(`roster.data.income.transactionlist.ch.["${portfolioIdencoded}"].["${startDate}"].["${endDate}"].["${prodType}"].["${ieFlag}"]`));
        } else {
          [oReturn] = await getValues(get(`roster.data.income.transactionlist.ch.["${portfolioId}"].["${startDate}"].["${endDate}"].["${prodType}"].["${ieFlag}"]`));

        }
        console.log("income.transactionHistoryCH rest calll!", oReturn);
        await set('income.transactionHistory', JSON.parse(oReturn));
      },
    })

    .path('ui.positions.currentPosition.transactions.moveToTransactionCH', {
      call: async ({ req }, { get, set, call }) => {


        const positionIndex = req.args[1];
        const link = req.args[2];

        const portfolioId = await getValues(get('app.user.selectedPortfolioId'));

        const [transactionLength] = await getValues(get([`roster.data.portfoliosById["${portfolioId}"].genericAssets.positions[${positionIndex}].transactions.length`]));

        set('ui.positions.currentPosition.transactions.length', transactionLength);

        await call('ui.history.replace', { pathname: link });


      },
    })



    .path('income.incomeExpenseSwitch', variable(0))
    .path('income.ieProdtype', variable(""))
    .path('chAuth.login', {
      call: async ({ req }, { get, set, call }) => {
        await call('queryString.extract');
        const [ret] = await getValues(get('auth.ret'));
        console.log("response from Ch login", ret);
        const [messages] = await getValues(get('i18n.messages'));
        if (parseInt(ret) === 0) { // response.ret && response.ret==0
          const [jwt] = await getValues(get('auth.jwt'));
          const [user] = await getValues(get('auth.user'));
          await Promise.all([
            set('auth.authHeader', jwt),
            set('auth.passwordExpired', ""),
            set('auth.sessionId', ""),
            set('auth.userId', user),
            set('auth.lastSession', ""),

          ]);
          await call('terms.showTermsConditionsCall');
          call('auth.setLanguageCode');
          if (config.features.vascoAuth) {
            await call('vasco.statusCheck');
            // await call('vasco.redirection');
            const [vascoFlow] = await getValues(get('auth.vascoFlow'));
            if (vascoFlow === VASCO_FLOW.browser) {
              await call('rsa.changePage');
              await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.pin2fa);
              const [vascoAuthorised] = await getValues(get('vascoauthentication.vascoAuthorised'));
              if (vascoAuthorised) {
                await call('portfolio.getAllInfo');
              }
            }
            else if (vascoFlow === VASCO_FLOW.failUserLocked) {
              await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.failUserLocked);
              await set('vascoauthentication.vascoVisible', true);
            }
            else {
              await set('auth.vascoFlow', VASCO_FLOW.notActivated);
              await set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.notActivated);
              await set('vascoauthentication.hideVascoActivatedFlag', true);
              await set('vascoauthentication.vascoVisible', true);
            }
          } else {
            await set('auth.vascoFlow', VASCO_FLOW.noVasco);
            await call('portfolio.getAllInfo');
          }

        } else if (ret == 401) {
          set('auth.errorMessage', messages['app.login.auth.error.expiredIDToken']);
          // await call('ui.history.replace', { pathname: '/login' });
        }
        else if (ret == 405) {
          set('auth.errorMessage', messages['app.login.auth.error.invalidRMAccess']);
        }
        else if (ret == "") {
          set('auth.errorMessage', messages['app.marque.unExpectederror']);
        }
        else if (ret == 404) {
          set('auth.errorMessage', messages['app.login.auth.error.userNotFound']);
        }
        else if (ret != 0) {
          set('auth.errorMessage', messages['app.marque.unExpectederror']);
        }
        else {
          set('auth.errorMessage', messages['app.marque.unExpectederror']);
        }
      }
    })
    .path('auth.setLanguageCode', {
      call: async ({ req }, { get, set, call }) => {
        const selLanguage = await AsyncStorage.getItem('SelectedLanguageCode');
        function get_language(selLanguage) {
          const dash_index = selLanguage.indexOf('-')
          if (dash_index >= 0) {
            return selLanguage.substring(0, dash_index)
          }
          return selLanguage
        }
        const selLangCode = selLanguage != null ? get_language(selLanguage) : null;
        const langCode = selLangCode == null ? 'en' : selLangCode;
        await set('auth.langCode', langCode);
      }
    })
    .path('portfolio.getAllInfo', {
      call: async ({ req }, { get, set, call }) => {
        const [authSuccess] = await getValues(get('auth.authorised'));

        const ran_str = "random" + Math.round(Math.random() * 1000);
        const [_entitlementList] = await getValues(get([
          `roster.data.getEntitlementList`,
        ]));


        if (_entitlementList.$type == "error") {

          // window.jwt = "";
          // window.user = "";
          // window.ret = "";

          await Promise.all([
            set('auth.ret', ""),
            set('auth.jwt', ""),
            set('auth.user', "")
          ]);


          call('ui.history.replace', { pathname: "/login" });


        }

        const parsedEntitlementData = JSON.parse(_entitlementList);
        const oEntitlementList = parsedEntitlementData;
        const entitlementModules = parsedEntitlementData && parsedEntitlementData.modules;
        await set('auth.entitlement', oEntitlementList);

        const portfolioRead = oEntitlementList.dashboard || oEntitlementList.portfolio || false;
        const maturitiesRead = oEntitlementList.maturities || false;
        const reportsRead = oEntitlementList.reports || false;
        const notificationRead = oEntitlementList.notification || false;

        if (entitlementModules.includes(ENTITLEMENT.tradingModule)) {
          await set('auth.entitlements.trading', true);
          // Feature/EBANK-17839 create app without rendering
          // const [showTrade] = await getValues(get('app.config.trading.tradeComponentDisabled'));
          // if(!showTrade)
          //   await set('auth.entitlements.trading',true);
        }

        if (!portfolioRead && !maturitiesRead && !reportsRead) {
          await set('auth.noEntitlement', true);
          set('auth.loginBusy', false);

          call('ui.history.replace', { pathname: "/login" });
          return;
        }

        await call('vasco.checkVascoFlow');

        let path = "";
        const [_portfoliosTop, _portfolioLength, _cache,] = await getValues(get([
          `roster.data.portfolios.top`,
          `roster.data.portfolios.length`,
          `roster.data.cache.${ran_str}`,
        ]));
        await set('app.user.portfolios.length', _portfolioLength);

        const topPortfolio = await JSON.parse(_portfoliosTop);
        const portfolioId = topPortfolio.id;
        const title = topPortfolio.title;
        const referenceCurrency = topPortfolio.referenceCurrency;
        const relId = topPortfolio.relId;
        const branchCode = topPortfolio.branchCode;
        const isPaymentAvailable = topPortfolio.isPaymentAvailable;

        if (portfolioId.$type == 'notFound') {
          await call('ui.history.replace', { pathname: '/noportfolios' });
          return;
        }

        const portfolio = { id: portfolioId, title, referenceCurrency, relId, branchCode, isPaymentAvailable };
        path = (portfolioRead && '/portfolios') || (maturitiesRead && '/maturities') || (reportsRead && '/reports');

        await set('auth.authorised', true);
        await set('auth.authSuccess', true);

        await set('app.user.selectedPortfolioId', portfolioId);
        await set('app.user.selectedPortfolioData', portfolio);

        const [_discoveryHistoryList] = await getValues(get([
          'roster.data.discovery.history'
        ]));
        if (_discoveryHistoryList.$type != 'error' || _discoveryHistoryList.$type != 'atom') {
          await set('discovery.history', JSON.parse(_discoveryHistoryList));
        } else {
          await set('discovery.history', []);
        }

        await call('auth.getUserInformation');
        await set('rsa.rsaAuthorised', true);
        set('ui.state.portfolio.view.selectedId', 'chart');
        set('portfolio.portfolioBarDismissed', false);
        set('auth.loginBusy', false);// EBANK-19400
        if (notificationRead) {
          call('notifications.getUserNotifications');
        }
        await call('auth.checkIsPaymentAvailable');
        // await call('auth.routesAfterLoginCH'); EBANK-19400
        await call('ui.history.replace', { pathname: path });
        await call('auth.routesAfterLoginCH');
      },
    })

    .path('auth.routesAfterLoginCH', {
      call: async ({ req }, { set, get, call }) => {
        const path = req.args[0];
        const [showTermsConditionsData] = await getValues(get(`roster.data.terms.showTermsConditions`));
        let tcData = '';
        if (showTermsConditionsData.$type == "error") {
          tcData = {
            'showTermsConditions': false,
            'tcPdfLink': '',
            'showPrivacyAgreement': '',
            'paPdfLink': '',
            'isRMUserGroup': '',
            'tcVersion': '',
            'paVersion': '',
            'newUserTc': '',
            'newUserPa': '',
            'ssVersion': '',
            'ssPdfLink': '',
            'showSummaryOfServices': false
          };
        } else {
          tcData = await JSON.parse(showTermsConditionsData);
        }
        const [authSuccess] = await getValues(get('auth.authSuccess'));
        const [passwordExpired] = await getValues(get('auth.passwordExpired'));
        const routePath = await getValues(get('auth.path'));
        const [vascoActivated] = await getValues(get('auth.vascoActivated'));
        const showTermsConditions = tcData.showTermsConditions;
        const tcPdfLink = tcData.tcPdfLink;
        const showPrivacyAgreement = tcData.showPrivacyAgreement;
        const paPdfLink = tcData.paPdfLink;
        const rmUserGroup = tcData.isRMUserGroup;
        const tcVersion = tcData.tcVersion;
        const paVersion = tcData.paVersion;
        const showSummaryOfServices = tcData.showSummaryOfServices;
        const ssPdfLink = tcData.ssPdfLink;
        const ssVersion = tcData.ssVersion;
        const [webssoEnabled] = await getValues(get('webssoauthentication.webssoEnabled'));
        const newUserTc = tcData.newUserTc;
        const newUserPa = tcData.newUserPa;
        // EBANK-19400
        const [gracePeriod] = await getValues(get('vascoauthentication.gracePeriod'));
        const [isNTBUser] = await getValues(get('vascoauthentication.isNTB'));
        const isRSAUser = (gracePeriod > 0) && !isNTBUser;
        const [eCredPwd] = await getValues(get('auth.eCredPwd'));
        // Validate if the forgot Password functionality is enabled or not
        const [isForgotPasswordEnabled] = await getValues(get('app.config.showchangepassword'));

        await Promise.all([
          set('terms.showTermsConditions', showTermsConditions),
          set('terms.tcPdfLink', tcPdfLink),
          set('terms.showPrivacyAgreement', showPrivacyAgreement),
          set('terms.paPdfLink', paPdfLink),
          set('terms.tcVersion', tcVersion),
          set('terms.paVersion', paVersion),
          set('terms.newUserTc', newUserTc),
          set('terms.newUserPa', newUserPa),
          set('terms.rmUserGroup', rmUserGroup),
          set('terms.showSummaryOfServices', showSummaryOfServices),
          set('terms.ssPdfLink', ssPdfLink),
          set('terms.ssVersion', ssVersion),
        ]);
        let isVascoNTB;
        const [twoFaRegisPendingCode] = await getValues(get('vascoauthentication.twoFaRegisPendingCode'));


        if (eCredPwd && eCredPwd.status === ECREDENTIALS.EPWD_RESET_INITIATED
          && eCredPwd.pwdValid && (eCredPwd.maxCount - eCredPwd.attemptCount) >= 0) {
            set('auth.loginBusy', false);
            await call('ui.history.replace', { pathname: '/profile/change-password' });
            return;
        }

        if (passwordExpired){
          if(isNTBUser || twoFaRegisPendingCode === VASCO_API_ERROR_CODES.TWOFA_REGISTRATION_PENDING){ // WMCE-39527 - User First time Onboarding via DWO Web
            set('vascoauthentication.vascoVisible', true);
            set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.ntbUser);
          }
          else if((eCredPwd && eCredPwd.status === ECREDENTIALS.EPWD_RESET_INITIATED)
          && eCredPwd.pwdValid && (eCredPwd.maxCount - eCredPwd.attemptCount) >= 0){
            const path = '/new-user-change-password';
            await call('auth.handler', { authSuccess, path });
          }else{
            const path = '/new-user-change-password';
            await call('auth.handler', { authSuccess, path });
          }
        }
        // if (eCredPwd && isForgotPasswordEnabled && eCredPwd.authCodeValid === false &&
        //   ((eCredPwd.maxCount - eCredPwd.attemptCount) >= 0)) {
        //   await set('forgotPassword.isForgotPwdAfterLogin', true);
        //   await set('forgotPassword.showForgotPwd', true);
        //   await set('auth.authorised', true);
        // }

        else if (!isRSAUser && !vascoActivated && !webssoEnabled) {

          set('vascoauthentication.vascoVisible', true);
          set('vascoauthentication.vascoModalType', VASCO_MODAL_TYPES.notActivated);

          [isVascoNTB] = await getValues(get('vascoauthentication.isNTB'));


        } else if ((showTermsConditions || showPrivacyAgreement || showSummaryOfServices) && !rmUserGroup && envConfig.envConfig !== EBANKINGWEBLUX) {
          const path = '/terms-conditions';
          await call('auth.dashboard2FARouting', { authSuccess, path });
        }else if ((showTermsConditions) && !rmUserGroup && envConfig.envConfig === EBANKINGWEBLUX) {
          const path = '/terms-conditions';
          await call('auth.dashboard2FARouting', { authSuccess, path });
        } else {
          await call('auth.dashboard2FARouting', { authSuccess, path });

        }
        set('auth.loginBusy', false);
        set('auth.entitlementProcessed', true);
      }
    })

    .path('queryString.extract', {
      call: async ({ req }, { get, set, call }) => {

        const ret = window.ret;
        const jwt = window.jwt;
        const user = window.user;
        console.log("JWT :=> ", jwt);
        set('auth.ret', ret);
        set('auth.jwt', jwt);
        set('auth.user', user);
      },
    })
    .path('auth.errorMessage', variable())
    .path('auth.code', variable())
    .path('auth.ret', variable())
    .path('auth.user', variable())
    .path('config.regionCode', variable('CH'))

    .path('auth.checkEntitlementUserPf', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        const [_entitlementUserPfList] = await getValues(get([`roster.data.getEntitlementUserPfList["${guidStr}"]`]));
        const oEntitlementUserPfList = JSON.parse(_entitlementUserPfList);
        if (Object.keys(oEntitlementUserPfList.entitlementUser).length === 0) {
          set('auth.noEntitlementUserPf', true);

        } else {
          set('auth.noEntitlementUserPf', false);
        }
      }
    })

    .path('auth.checkIsPaymentAvailable', {
      call: async ({ req }, { get, set, call }) => {
        /* WMCE-4427 getInActivePortfolioLength shifted to getDashboardData Path */
      //  const [result, inActivePortfolioCount] = await getValues(get(['roster.data.paymentsAvailableCheck.getData', 'roster.data.portfolios.getInActivePortfolioLength']));
      const [result] = await getValues(get('roster.data.paymentsAvailableCheck.getData'));
      isValidJsonString(result).then(async (data) => {
          set('auth.paymentAvailableList', data);
        }).catch(async (error) => {
          set('auth.paymentAvailableList', []);
        });
        // try {
        //   if (inActivePortfolioCount > 0) {
        //     set('auth.isNonActivePortfolio', true);
        //   } else {
        //     set('auth.isNonActivePortfolio', false);
        //   }
        // } catch (err) {
        //   set('auth.isNonActivePortfolio', false);
        // }
      }
    })
    .path('auth.showPaymentLimitAvailable', {
      call: async ({ req }, { get, set, call }) => {
        const channel = 'WEB';
        const [paymentEnabled] = await getValues(get('auth.isPaymentCheck'));
        const [isRMUserGroup] = await getValues(get('auth.isRMUserGroup'));  {/* WMCE-3262 : If RM user group is 95, dont display the payment limit popup */}
        const guidStr = Guid();
        if (paymentEnabled) {
          const [paymentLimit] = await getValues(get([`roster.data.userProfile.getPaymentLimit["${channel}"]["${guidStr}"]`]));
          // set showPmtTxLimitMsg muster variables
          try {
            if (paymentLimit && !isRMUserGroup)
              await Promise.all([set('app.user.profile.showPmtTxLimitMsg', JSON.parse(paymentLimit).showPmtTxLimitMsg), set('app.user.profile.paymentTxLimit', JSON.parse(paymentLimit).txLimit)]);

            else
              await Promise.all([set('app.user.profile.showPmtTxLimitMsg', false), set('app.user.profile.paymentTxLimit', null)]);
          } catch (err) {
            set('app.user.profile.showPmtTxLimitMsg', false);
          }
        }
      }
    })
    // JIRA WMCE-406 -  entitlement-user-pf and user-entitlement call
    .path('auth.entitlementCheck', {
      call: async ({ req }, { get, set, call }) => {
        const guidStr = Guid();
        // const _entitlementListData = await getValues(get(`roster.data.getEntitlementList`));

        const [clientAdminAccess, _entitlementListData] = await getValues(get(['auth.clientAdminAccess', 'auth.entitlement']));
        const parsedEntitlementData = await JSON.parse(_entitlementListData);
        const oEntitlementList = parsedEntitlementData;
        const entitlementModules = parsedEntitlementData && parsedEntitlementData.modules;
        const adminRead = oEntitlementList.marqueeadmin || (oEntitlementList.esign_rmops && clientAdminAccess) || false;
        await set('auth.entitlement', oEntitlementList);
        await set('auth.isAdminUser', adminRead);
  
          // EBANK-19400

          const portfolioRead = oEntitlementList.dashboard || oEntitlementList.portfolio || false;
          const maturitiesRead = oEntitlementList.maturities || false;
          const insightsRead = oEntitlementList.insights || false;
          const reportsRead = oEntitlementList.reports || false;
          const notificationRead = oEntitlementList.notification || false;
          const isNotificationDisabledForRM = oEntitlementList.notifications_disabled || false;
          const isRMUserGroup = oEntitlementList.userGroup || null;

          /* WMCE-2087 paymentSubmitDisabled flag added for RM access */
          const paymentSubmitDisabled = oEntitlementList.payment_submit_disabled || false;
          if (paymentSubmitDisabled){
            await set('auth.paymentSubmitDisabled', true);
          }
          /* WMCE-2915 beneficiaryDisable flag and settings disable added for RM access */
          if(oEntitlementList.add_beneficiary_disabled){
            await set('auth.addBeneficiaryDisabled', true);
          }
          if(oEntitlementList.settings_disabled){
            await set('auth.settingsDisabled', true);
          }
          /* WMCE-3068 download disabled flag and read flag added for RM access */
          if(oEntitlementList.document_download_disabled){
            await set('auth.documentDownloadDisabled', true);
          }
          /* WMCE-42437 preview disabled flag to disable report preview for RM access */
          if(oEntitlementList.document_preview_disabled){
            await set('auth.documentPreviewDisabled', true);
          }
          
          if(oEntitlementList.document_read_disabled){
            await set('auth.documentReadDisabled', true);
          }
          
          if(isNotificationDisabledForRM){
            await set('auth.isNotificationDisabledForRM', true);
          }

          if(isRMUserGroup === RM_ACCESS.RM_USER_GROUP){
            await set('auth.isRMUserGroup', true);
          }
          if (entitlementModules.includes(ENTITLEMENT.tradingModule)) {
            await set('auth.entitlements.trading', true);
            // Feature/EBANK-17839 create app without rendering
            // const [showTrade] = await getValues(get('app.config.trading.tradeComponentDisabled'));
            // if(!showTrade)
            //   await set('auth.entitlements.trading', true);
          }

          if (entitlementModules.includes(ENTITLEMENT.dataExtracts)) {
            await set('auth.entitlements.dataExtracts', true);
          }
          if (entitlementModules.includes(ENTITLEMENT.transactions)) {
            await set('auth.entitlements.transactions', true);
          }
          if (!adminRead && !portfolioRead && !maturitiesRead && !insightsRead && !reportsRead) {
              set('auth.noEntitlement', true);
              await set('auth.authorised', false);
              set('auth.loginBusy', false);
              await call('ui.history.replace', { pathname: '/login' });
              return;
          }

          let path = "";
          if (!adminRead) {
            // Instead of initializing rsa.rsaAuthorised value here we have moved it to resetInfoMessage on login
            // As this api call has been shifted to dashboard this call reinitialize the rsa variables which are set in ETB flow
            const [webssoEnabled] = await getValues(get('webssoauthentication.webssoEnabled'));
            path = (portfolioRead && '/portfolios') || (maturitiesRead && '/maturities') || (insightsRead && '/insights') || (reportsRead && '/reports');

            if (webssoEnabled) {
              await set('rsa.rsaAuthorised', true);
            }
            // else {
            //   await set('rsa.rsaAuthorised', false);
            // }

          }
          else {
            path = '/admin';
            await set('auth.authorised', true);
            await set('rsa.rsaAuthorised', false);
          }
          await set('auth.entitlementPath', path);
        
      },
    })
    
    /* WMCE- 4427 New path added for batching dashboard API calls */
    .path('auth.getDashboardSummaryData', {
      call: async ({ req }, { get, set, call }) => {
        
        const ranStr = "random" + Math.round(Math.random() * 1000);
        const [messages , prefCurrency, ] = await getValues(get(['i18n.messages', 'userprofile.prefCurrency']));
        /* WMCE- 4862 , Merging top and length call in single API call */
        const [
          // _portfoliosTop, _portfolioLength, 
          inActivePortfolioCount, _discoveryHistoryList, _entitlementListData,
          portfolioData ,pfMapData] = await getValues(get([
          // `roster.data.portfolios.top`,
          // `roster.data.portfolios.length`,
          `roster.data.portfolios.getInActivePortfolioLength`,
          'roster.data.discovery.history',
          `roster.data.getEntitlementList`,
          'roster.data.portfolios.getData',
          `roster.data.userprofile.getPfMapData`,

        ]));

        const [langCode] = await getValues(get('auth.langCode'));
        let languageObj = languageData.languageList[0];
        languageData.languageList.every((element, index) => {
          if (element.langCode.toLowerCase().indexOf(langCode.toLowerCase()) !== -1) {
            languageObj = element;
            return false;
          } return true;
        });

        const [isLanguageChangeFromLogin] = await getValues(get('languages.isLanguageChange'));
        if (isLanguageChangeFromLogin) {
          await call('userprofile.saveUserPrefLanguage', { prefLanguage: languageObj });
          await set('languages.isLanguageChange',false)
        }
        
        await set('auth.entitlement', _entitlementListData);
      
        await call('auth.entitlementCheck');
        
        // /userdetails/get/pf-relid-map
        isValidJsonString(pfMapData).then(async (data) => {
          if(data&& data.retCode === '0' ){
          await set('portfolio.pfMapData', data.portfolios);
         
        }
        }).catch(() => {
        });
       
        if (_discoveryHistoryList.$type !== 'error' || _discoveryHistoryList.$type !== 'atom') {
          await set('discovery.history', _discoveryHistoryList);
        } else {
          await set('discovery.history', []);
        }
        
        isValidJsonString(portfolioData).then(async (data) => {
            if (isEmpty(data[0])) {
            await set('auth.invalidLogin', true);
            await set('auth.errorMsg', messages['app.auth.portfolio.noAccess']);
            set('auth.loginBusy', false);
            return;
          }
          set('app.user.portfolios.length', data.length);
          set('app.user.portfolios', data);
          const topPortfolio = data[0];
          const portfolioId = topPortfolio.id !== null? topPortfolio.id :topPortfolio.relId;
          const title = topPortfolio.title;
          const referenceCurrency = topPortfolio.referenceCurrency;
          const relId = topPortfolio.relId;
          const relIdType = topPortfolio.relIdType;
          const pfType = topPortfolio.pfType;
          const branchCode = topPortfolio.branchCode;
          const isPaymentAvailable = topPortfolio.isPaymentAvailable;
          if (portfolioId.$type === 'notFound') {
            await call('ui.history.replace', { pathname: '/noportfolios' });
            return;
          }

          const portfolio = { id: portfolioId, title, referenceCurrency, relId, relIdType,pfType, branchCode, isPaymentAvailable };

          await set('app.user.selectedPortfolioData', portfolio);
          await set('app.user.selectedPortfolioId', portfolioId);
          await set('app.user.selectedPortfolio', portfolio);
          if (prefCurrency === null)
          await set('userprofile.prefCurrency', portfolio.referenceCurrency);
          await set('auth.authorised', true);
          set('ui.state.portfolio.view.selectedId', 'chart');
          set('portfolio.portfolioBarDismissed', false);

        }).catch(async (error) => {
            await set('auth.invalidLogin', true);
            await set('auth.errorMsg', messages['app.auth.portfolio.noAccess']);
            set('auth.loginBusy', false);
            return;
        });

        try {
          if (inActivePortfolioCount > 0) {
            set('auth.isNonActivePortfolio', true);
          } else {
            set('auth.isNonActivePortfolio', false);
          }
        } catch (err) {
          set('auth.isNonActivePortfolio', false);
        }
        // Transition to Dashboard screen done with reference to what changes were done in Performance
        const [loadportfoliosrc] = await getValues(get('auth.loadportfoliosrc'));
        if (loadportfoliosrc) {
          call('ui.history.push', { pathname: '' });
          await set('auth.loadportfoliosrc', false);
        }
        call('notifications.getUserNotifications'); 
        await call('alerts.list');   // WMCE-52952 - condition for UK is now handled from database only
        call('auth.enablePaymentByPortfolioId');
      }
    })

    .path('auth.enablePaymentByPortfolioId', {
      call: async ({ req }, { get, set, call }) => {
        const [selectedPortfolioData] = await getValues(get('app.user.selectedPortfolioData'));
        await set('auth.isPaymentCheck', selectedPortfolioData.isPaymentAvailable);
      }
    })

    .path('auth.userGroupCheck', {
      call: async ({ req }, { get, set, call }) => {
        const [userGroup] = await getValues(get('auth.userGroup'));
        if (userGroup === 95) {
          await set('auth.noRmAccess', true);

        }
      }
    })

    // WMCE-4443 , Get pfRelId Mapping when user makes changes in consolidation view
    .path('auth.getPFData', {
      call: async ({ req }, { get, set, call }) => {
        const [pfMapData] = await getValues(get([`roster.data.userprofile.getPfMapData`]));
        // /userdetails/get/pf-relid-map
        isValidJsonString(pfMapData).then(async (data) => {
          if(data&& data.retCode === '0' ){
          await set('portfolio.pfMapData', data.portfolios);
         
        }
        }).catch(() => {
        });
      }
     })

    .path('portfolio.getSelectedIdData', {
      call: async ({ req }, { get, set, call }) => {
        const [portfolioData, pfMapData] = await getValues
                (get(['app.user.selectedPortfolioData','portfolio.pfMapData']));
        const pfIdArray = [];
        pfMapData.map((portfolio) => {
          if(portfolio.relId === portfolioData.relId && portfolio.relIdType.toString() === portfolioData.relIdType){
              pfIdArray.push(portfolio.pfId);
          }
        });
        await set('user.selectedPortfolioIds',pfIdArray);
      }
    })
   
    .path('config.docsign', variable(false))
    .path('config.chat', variable(false))
    .path('user.selectedPortfolioIds', variable(null))
    .path('portfolio.pfMapData', variable(null));
}

